import MayaSidebarToolbox from './MayaSidebarToolbox'
import SidebarOutliner from './SidebarOutliner'
import { MOTION } from '../lib/motion'

const Sidebar = ({ introStaggerMs = MOTION.ms.introStagger }) => (
  <aside className="site-sidebar-dock" aria-label="Site navigation">
    <MayaSidebarToolbox introStaggerMs={introStaggerMs} />
    <SidebarOutliner introStaggerMs={introStaggerMs} />
  </aside>
)

export default Sidebar
